import dayjs from "dayjs";
import { useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { saveProgressToServerThunk } from "@/store/thunks";

const SYNC_INTERVAL_MS = 60 * 1000;

export const useSaveStoreToServer = () => {
    const { offlineMode, isInitialDataLoading } = useAppSelector(
        (s) => s.offline,
    );
    const { role } = useAppSelector((s) => s.user);
    const {
        progress: { lastModifiedAt, lastSyncedAt },
    } = useAppSelector((s) => s.offline);

    const dispatch = useAppDispatch();
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (role === "sv" || role === "svm") return;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (
            offlineMode ||
            !lastModifiedAt ||
            dayjs(lastSyncedAt).isAfter(dayjs(lastModifiedAt)) ||
            isInitialDataLoading
        ) {
            return;
        }

        const lastSyncTime = dayjs(lastSyncedAt);
        const timeSinceLastSync = dayjs().diff(lastSyncTime, "milliseconds");

        const timeUntilNextSync = Math.max(
            0,
            SYNC_INTERVAL_MS - timeSinceLastSync,
        );

        timeoutRef.current = setTimeout(() => {
            dispatch(saveProgressToServerThunk());
        }, timeUntilNextSync);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [offlineMode, lastModifiedAt, lastSyncedAt, role, dispatch]);
};
